import axios from "axios";
import {
    CreateUserRequest,
    CurrentUser,
    UpdateUserRequest,
    User,
    UserResponse,
    UserUpdateResponse
} from "../models/users.models";


export const usersService = {
    fetchUsers: async (page = 0, size = 10, searchValue?: string, role?: string, activated?: boolean): Promise<UserResponse> => {
        const params = {
            page,
            size,
            q: searchValue,
        };

        const response = await axios.get<UserResponse>('/users', {params});
        return response.data;
    },

    fetchUserData: async (userId: number): Promise<User> => {
        const response = await axios.get<User>(`/users/${userId}`);
        return response.data;
    },

    fetchLoggedInUser: async (): Promise<CurrentUser> => {
        const response = await axios.get<CurrentUser>(`/users/currentUserDetails`);
        return response.data;
    },

    updateUserData: async (userEmail: string, requestBody: UpdateUserRequest): Promise<UserUpdateResponse> => {
        const response = await axios.patch(`/users`, requestBody, { params: { userEmail } });
        return response.data;
    },

    createUser: async (params: CreateUserRequest): Promise<void> => {
        await axios.post(`/users`, {
            ...params,
            role: 'USER'
        });
    },

    deleteUser: async (userEmail: string): Promise<UserUpdateResponse> => {
        const requestBody = { userEmail };
        const response = await axios.delete('/users', {data: requestBody});
        return response.data;
    },

    sendWelcomeEmail: async (userId: number): Promise<void> => {
        await axios.post(`/users/${userId}/send-welcome-email`);
    },

    appHasSystemAdmin: async (): Promise<boolean> => {
        const response = await axios.get<boolean>('/users/has-system-admin');
        return response.data;
    },
};